export const HOME = {
  emergentLink: "home-emergent-link",
  navReserve: "nav-reserve-cta",
  navMobileToggle: "nav-mobile-toggle",
  heroReserve: "hero-reserve-cta",
  heroExplore: "hero-explore-cta",
  stickyMobileReserve: "sticky-mobile-reserve-cta",
  reserveSectionCta: "reserve-section-cta",
  finalCta: "final-cta-button",
  mentorBioLink: "mentor-bio-link",
  resultsCta: "results-cta-button",
  faqTrigger: "faq-trigger",
  reserveModal: "reserve-modal",
  reserveModalConfirm: "reserve-modal-confirm",
  reserveModalClose: "reserve-modal-close",
  reserveModalName: "reserve-modal-name",
  reserveModalEmail: "reserve-modal-email",
  reserveModalPhone: "reserve-modal-phone",
  roadmapModule: "roadmap-module",
  videoCard: "video-card",
};
